"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchManaBalance = void 0;
const units_1 = require("@ethersproject/units");
const chainConfiguration_1 = require("decentraland-dapps/dist/lib/chainConfiguration");
const isEthereumAddress_1 = __importDefault(require("validator/lib/isEthereumAddress"));
const rollbar_1 = __importDefault(require("../development/rollbar"));
const segment_1 = __importDefault(require("../development/segment"));
const Loader_1 = __importDefault(require("./Loader"));
require("isomorphic-fetch");
const QUERY = `
query ($address: String!) {
  accounts(where: { id: $address }) {
    id,
    mana
  }
}
`;
function fetchManaBalance(address, chainId) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        if (!(0, isEthereumAddress_1.default)(address)) {
            return 0;
        }
        try {
            const response = yield fetch(chainConfiguration_1.MANA_GRAPH_BY_CHAIN_ID[chainId], {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    query: QUERY,
                    variables: { address: address.toLowerCase() },
                }),
            });
            const body = yield response.json();
            const accounts = ((_a = body === null || body === void 0 ? void 0 : body.data) === null || _a === void 0 ? void 0 : _a.accounts) || [];
            const account = accounts[0];
            const mana = (account === null || account === void 0 ? void 0 : account.mana) || '0';
            return parseFloat((0, units_1.formatUnits)(mana, 'ether'));
        }
        catch (err) {
            console.error(err);
            (0, rollbar_1.default)((rollbar) => rollbar.error(err));
            (0, segment_1.default)((analytics) => analytics.track('error', Object.assign(Object.assign({}, err), { message: err.message, stack: err.stack })));
            return 0;
        }
    });
}
exports.fetchManaBalance = fetchManaBalance;
function createBalanceLoader(chainId) {
    return new Loader_1.default((address) => __awaiter(this, void 0, void 0, function* () {
        return fetchManaBalance(address, chainId);
    }));
}
const cache = new Map();
function manaBalance(chainId) {
    if (!cache.has(chainId)) {
        cache.set(chainId, createBalanceLoader(chainId));
    }
    return cache.get(chainId);
}
exports.default = manaBalance;
